import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import linkedin from "../../images/smicons/linkedin-white.svg";
import twitter from "../../images/smicons/twitter-white.svg";
import Logo from "../Image/Logo";
import "./Footer.scss";
import SubscribeForm from "../Footer/SubscribeForm";
import Consultation from "../MoreInfo/Consultation";

const Footer = ({ siteTitle, consultationBackgroundColorGrey = false }) => (
  <>
    <Consultation backgroundColorGrey={consultationBackgroundColorGrey} />
    <footer className="py-4" role="contentinfo">
      <div className="container max-w-[2500px] px-4">
        <div className="flex flex-col lg:flex-row lg:gap-6">
          <div className="w-full lg:w-2/4 mb-12 lg:mb-0 lg:p-4">
            <h3 className="mb-4">Contact Us</h3>
            <div className="mt-2 mb-1">
              <a href="mailto:contact@hamari.agency" aria-label="Email address">
                contact@hamari.agency
              </a>
            </div>
            <div className="mb-1">
              <a href="tel:+447540552750">
                +44 754 055 2750
              </a>
            </div>

            <Link to="/sitemap-index.xml" className="hover:text-hamariGrey">
              sitemap
            </Link>
            <h3 className="mt-5 mb-0">Follow Us</h3>
            <div className="flex pt-3">
              <a
                className="animate-underline"
                href="https://uk.linkedin.com/company/hamari-labs"
                rel="noopener noreferrer"
                aria-label="Follow us on LinkedIn"
                target="_blank"
              >
                <img src={linkedin} alt="linkedin" className="w-6 my-0 mr-1" />
              </a>
              <a
                className="animate-underline"
                href="https://twitter.com/hamarilabs"
                rel="noopener noreferrer"
                aria-label="Follow us on X"
                target="_blank"
              >
                <img src={twitter} alt="twitter" className="w-6 my-0 mx-1" />
              </a>
            </div>
          </div>
          <div className="w-full lg:w-2/4 mb-12 lg:mb-0 lg:p-4">
            <h3 className="mb-4">Hamari Agency</h3>
            <div className="mt-2 mb-1">
              6th Floor - Regus, 120 Bark Street, Bolton, England, BL1 2AX
            </div>
            <div className="mb-1">Company Number: 10713877</div>
            <Link to="/about/" className="mb-4 block">
              About Us
            </Link>
            <Link to="/privacy-and-cookies-policy/" className="mb-1 block">
              Privacy and cookies policy
            </Link>
            <Link to="/terms-of-service/" className="block mb-6 hover:text-hamariGrey">
              Terms of Service
            </Link>
            <button id="ot-sdk-btn" className="ot-sdk-show-settings bg-[#fff] hover:bg-green-400">
              Cookie Settings
            </button>
          </div>
          <div className="w-full lg:w-2/4 mb-12 lg:mb-0 lg:p-4">
            <h3 className="mb-4">Subscribe</h3>
            <p className="mb-3">Get B2C and B2B growth strategies trusted by leading brands</p>
            <SubscribeForm />
          </div>
          <div className="w-full lg:w-2/4 mb-12 lg:mb-0 lg:p-2">
            <Link to={"/"} className="flex items-center">
              <div className="logo pr-2">
                <Logo />
              </div>
              <span className="text-white hover:!text-neutral-500 font-normal text-2xl font-coreCircus">
                {siteTitle}
              </span>
            </Link>
          </div>
        </div>
      </div>
      <a href="tel:+447540552750" className="footer-call-button">Tap to Call</a>
    </footer>
  </>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer